import {
  SuggestedCategory,
  suggestedCategoryFromResponse,
} from './SuggestedCategory';
import {
  ProductSummary,
  productSummaryFromResponse,
} from '../Product/ProductSummary';

export interface Suggestions {
  categories: SuggestedCategory[];
  products: ProductSummary[];
}

export const suggestionsFromResponse = (responseData: any): Suggestions => ({
  categories: (responseData.categories ?? []).map(
    suggestedCategoryFromResponse,
  ),
  products: (responseData.products ?? []).map(productSummaryFromResponse),
});

export const getEmptySuggestions = (): Suggestions => ({
  categories: [],
  products: [],
});
